import { useMutation, useQueryClient } from '@tanstack/react-query';
import { groupsQueryOptions } from '@/hooks/contacts/use-groups';
import { generateGroupInfoQueryOptions } from '@/hooks/groups/use-group-info';
import { allChatSessionQueryOptions } from '@/hooks/sessions/use-conversation-sessions';
import type { ConversationMessageTypeUnion } from '@/models/conversations/conversation';
import type { RespondedType, ResponseError } from '@/models/response';
import { fetcher } from '@/utils/fetcher';

export default function useJoinGroup(isPrivateGroup = false) {
  const queryClient = useQueryClient();

  return useMutation<RespondedType, ResponseError, JoinGroupRequest>({
    mutationKey: [isPrivateGroup ? '/ApplyJoinGroup' : '/JoinGroup'],
    mutationFn: (params) => {
      const request: Record<string, unknown> = { GroupID: params.groupId };
      if (params.remark) {
        request.Remark = params.remark;
      } else if (params.message) {
        request.ChatID = params.message.ID;
        request.InviterUserId = params.message.UserID;
      }

      return fetcher(isPrivateGroup ? '/ApplyJoinGroup' : '/JoinGroup', request, { validResponseCodes: [0] });
    },
    onSuccess: (_, params) =>
      Promise.allSettled([
        queryClient.invalidateQueries(groupsQueryOptions),
        queryClient.invalidateQueries(generateGroupInfoQueryOptions(params.groupId)),
        queryClient.invalidateQueries(allChatSessionQueryOptions),
      ]),
  });
}

type JoinGroupRequest = {
  groupId: number;
  remark?: string;
  message?: Pick<ConversationMessageTypeUnion, 'ID' | 'UserID'>;
};
